export type CancelablePromise<TData = any> = Promise<{
  readonly body: TData;
  readonly ok: boolean;
  readonly status: number;
  readonly statusText: string;
  readonly url: string;
}> & {
  readonly cancel: () => void;
};

export const cancelOnSignal = <TData>(
  request: CancelablePromise<TData>,
  signal: AbortSignal,
): CancelablePromise<TData> => {
  const cancelRequest = () => request.cancel?.();
  const removeListener = () => signal.removeEventListener('abort', cancelRequest);

  if (signal.aborted) {
    cancelRequest();
    return request;
  }

  signal.addEventListener('abort', cancelRequest, { once: true });
  request.then(removeListener, removeListener);

  return request;
};
